import { Box, Container } from '@mui/material';
import React from 'react';
import { MrWrapper, Wrapper } from './RefundPolicy.styled';
import { GeneralText } from '../../components/General/Text';


const RefundPolicy = () => {
  return (
    <Container>
      <Wrapper>
        <GeneralText variant='h1'>Refund Policy for DSA Students</GeneralText>
        <GeneralText variant='h2'>Introduction</GeneralText>
        <MrWrapper>
          <GeneralText variant='p'>Whilst we aim to get your equipment right the first time, there may be instances where you need to request a refund from us.
            This policy applies only to equipment supplied to you by Study Tech and covers the limited circumstances where refunds may be necessary.
          </GeneralText>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='p'>
            Our refund policy is designed to offer a fair service whilst ensuring proper use of DSA funding. <br />
            Should you have a dispute with a refund request, you maintain the right to raise this through your payment card issuer. However, that will suspend the process set out below and we will then work directly with your card issuer following their dispute process, which may result in a longer resolution time.
          </GeneralText>
        </MrWrapper>

        <GeneralText variant='h4'>1. Conditions for Refunds</GeneralText>
        <MrWrapper>
          <GeneralText variant='pSemibold'>Equipment Condition Requirements:</GeneralText>
        </MrWrapper>
        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>Items must be returned with all original accessories, packaging, cables, and documentation</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Light testing and initial setup to verify compatibility is permitted</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Items showing excessive wear, damage, or heavy use beyond initial testing are not eligible for refund</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Original packaging may be opened but must be retained and used for return shipping</GeneralText>
            </li>

          </ul>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='pSemibold'>Return Timeframes:</GeneralText>

        </MrWrapper>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>Contact our Customer Care Team within 14 days of delivery to request a return</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Return items within 28 days of original delivery date (applies per shipment)</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Return shipping costs are the customer's responsibility</GeneralText>
            </li>
          </ul>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='pSemibold'>Packaging for Return:</GeneralText>
        </MrWrapper>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>Use appropriate protective packaging to prevent damage during transit</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>We recommend photographing items before packaging as this can help resolve any condition disputes quickly</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>If you don't have suitable packaging materials, contact our Customer Care Team for advice</GeneralText>
            </li>
          </ul>
        </MrWrapper>

        <GeneralText variant='h4'>2. When Refunds Apply</GeneralText>

        <MrWrapper>
          <GeneralText variant='pSemibold'>Equipment Defects: </GeneralText>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='p'>Most equipment issues are resolved through manufacturer warranty or our insurance and warranty scheme rather than refunds. Contact our Customer Care Team to arrange replacement or repair through the appropriate warranty process.</GeneralText>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='p'>Refunds for defective equipment only apply to:</GeneralText>
        </MrWrapper>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>Non-DSA funded items where warranty replacement is not available</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Items you have personally paid for (such as laptop contributions or upgrades) where warranty processes cannot resolve the issue</GeneralText>
            </li>
          </ul>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='pSemibold'>Compatibility Issues:</GeneralText>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='p'>Equipment that works as designed but proves incompatible with your existing setup may be eligible for refund if:</GeneralText>
        </MrWrapper>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>The item was purchased as an upgrade beyond original DSA recommendations</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>The incompatibility issue was not reasonably foreseeable from the information provided during assessment</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Processing fee may apply where inadequate system information was provided (assessed case-by-case)</GeneralText>
            </li>
          </ul>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='pSemibold'>Items Not Eligible for Return:</GeneralText>
        </MrWrapper>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>DSA-recommended items that function correctly (these were specifically assessed for your needs and have been identified as being required to enable your studies)</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Ergonomic equipment recommended through the DSA assessment</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Opened in-ear headphones (hygiene reasons)</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Items damaged through misuse</GeneralText>
            </li>
          </ul>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='pSemibold'>Custom Build Equipment:</GeneralText>
        </MrWrapper>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>Items configured to your specific requirements (typically Apple computers) cannot be returned for a refund, even within the 14-day period, unless they are faulty or damaged. You will be clearly notified during the ordering process when an item is a custom build. This restriction applies because manufacturers will not accept returns of bespoke configurations that have been built to individual specifications</GeneralText>
            </li>
          </ul>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='pSemibold'>Change of Mind Returns:</GeneralText>
        </MrWrapper>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>Items that work correctly but you prefer a different option are only eligible for refund if purchased as upgrades beyond original DSA recommendations. £25 processing fee applies</GeneralText>
            </li>
          </ul>
        </MrWrapper>

        <MrWrapper>
          <GeneralText variant='pSemibold'>Additional Terms:</GeneralText>
        </MrWrapper>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>Return rights apply per shipment within stated timeframes</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>We reserve the right to investigate patterns of excessive returns</GeneralText>
            </li>
          </ul>
        </MrWrapper>


        <GeneralText variant='h4'>3. Refund Process</GeneralText>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>You have 14 days from delivery to contact our Customer Care Team to request a return. The Customer Care Team will assess whether the request meets the criteria outlined above</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>If the request is approved, you then have a further 14 days (28 days from receipt of merchandise) to return the goods at your own expense</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Once the equipment is received, it will be inspected as per the conditions outlined in Section 1 of this policy</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>If the item passes the inspection, the refund will be processed within 10 business days via the original payment method, minus any applicable processing fees</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>The customer will be notified of the outcome</GeneralText>
            </li>
          </ul>
        </MrWrapper>


        <GeneralText variant='h4'>4. Refund Amount</GeneralText>

        <MrWrapper>
          <ul>
            <li>
              <GeneralText variant='p'>The refund amount will be the price you paid for the equipment, minus any applicable processing fees</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>You will not be refunded any associated shipping costs incurred at the time of order or when returning the equipment</GeneralText>
            </li>
            <li>
              <GeneralText variant='p'>Processing fees:</GeneralText>

              <ol className='with-numbers'>
                <li>
                  <GeneralText variant='p'>£25.00 applies to change of mind returns</GeneralText>
                </li>
                <li>
                  <GeneralText variant='p'>£25.00 may apply to compatibility issues where inadequate system information was provided (as assessed case-by-case)</GeneralText>
                </li>
                <li>
                  <GeneralText variant='p'>No fee for approved defective equipment returns</GeneralText>
                </li>
              </ol>
            </li>

          </ul>
        </MrWrapper>

        <GeneralText variant='h4'>5. Contact Information</GeneralText>

        <MrWrapper>
          <GeneralText variant='p'>For any questions, please contact our Customer Care Team at <a href='mailto:orders@study.tech' className='email-link'>orders@study.tech</a> or</GeneralText> <GeneralText variant='pBold'>020 4532 2084 </GeneralText> <GeneralText variant='p'>Option 2.</GeneralText>
        </MrWrapper>


      </Wrapper>
    </Container>
  );
};

export default RefundPolicy;



